module.exports = "<app-item-report-inventory [showItemDetails]=\"showItemDetails\"></app-item-report-inventory>"